NP.Browser = {
	v: function(){
		var v = 99999;
		if( navigator.appVersion.indexOf( 'MSIE' ) !== -1 )
			v = parseFloat( navigator.appVersion.split( 'MSIE' )[ 1 ] );
			return v;
	}
};
NP.loadScript = function( url, callback ){
	var script = document.createElement( 'script' );
	script.type = 'text/javascript';
	
	if( script.readyState ){
		script.onreadystatechange = function(){
			if( script.readyState == 'loaded' || script.readyState == 'complete' ){
				script.onreadystatechange = null;
				callback();
			};
		}
	}else{
		script.onload = function(){
			callback();
		};
	}
	
	script.src = url;
	document.getElementsByTagName( 'head' )[ 0 ].appendChild( script );
};	

(function( $ ){
	if( NP.Browser.v() < 9 ){
		NP.loadScript( NP.STATIC_URL+'/common/js/lib/html5.js', function(){
			//$( '#writeShort' ).parent().attr( 'id', 'MSIE' );
			//$( 'body' ).attr( 'id', 'MSIE' );
		});
	}else{
		//$( 'body' ).attr( 'id', 'HTML5' );
	}
})( jQuery );